// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  padding: 0.75rem 1rem;
  border-radius: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const Status = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StatusContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;
